import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'mcp-trigger',
  name: 'MCP Server',
  category: 'triggers',
  description: 'Expose this workflow as an MCP tool that can be called by external AI agents and MCP clients',
  icon: 'Server',
  color: 'green',
  version: '1.0.0',
  
  group: ['trigger'],
  
  defaults: {
    name: 'MCP Server',
    color: '#10b981'
  },
  
  subtitle: '={{ $parameter.toolName || "MCP Tool" }}',
  
  inputs: [],
  
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Main'
    }
  ],
  
  tags: ['mcp', 'trigger', 'server', 'ai', 'agent', 'tool'],
  
  comingSoon: false,
  
  metadata: {
    documentation: 'Exposes this workflow as an MCP tool that can be called by external AI agents like Claude Desktop or other MCP clients.'
  }
};

export default definition;
